import StaffShow from "../components/staff/Show";

export default [
  { name: 'Staff', path: '/staff', component: StaffShow,  }
]
